import { render, staticRenderFns } from "./DevTool.vue?vue&type=template&id=463e88a2&scoped=true"
import script from "./DevTool.vue?vue&type=script&lang=js"
export * from "./DevTool.vue?vue&type=script&lang=js"
import style0 from "./DevTool.vue?vue&type=style&index=0&id=463e88a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463e88a2",
  null
  
)

export default component.exports